import { Button, MessageBar, MessageBarBody } from '@fluentui/react-components';
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { logger } from '../lib/logger';

interface ErrorBoundaryState {
  error: Error | null;
  info: ErrorInfo | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null, info: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error, info: null };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    logger.error('[taskpane] render crashed', { err: error, info });
    this.setState({ error, info });
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="min-h-screen bg-sf-surface p-4">
        <MessageBar intent="error">
          <MessageBarBody>
            <div className="flex flex-col gap-3">
              <div>
                <p className="font-semibold">AIRA could not start</p>
                <p>{this.state.error.message || String(this.state.error)}</p>
              </div>
              {this.state.info?.componentStack && (
                <pre className="max-h-56 overflow-auto whitespace-pre-wrap rounded-md bg-white p-2 text-[10px] text-sf-body">
                  {this.state.info.componentStack}
                </pre>
              )}
              <Button appearance="primary" size="small" onClick={() => window.location.reload()}>
                Restart
              </Button>
            </div>
          </MessageBarBody>
        </MessageBar>
      </div>
    );
  }
}
